import React, { useEffect, useState, useMemo } from 'react';
import DataTable from '../General/DataTable';
import API_STATES from '@/constants/StateConstants';
import { ByzzerMask } from '../General/ByzzerMask/ByzzerMask';
import generalStyles from '@/components/General/Styles.module.scss';
import { getTestAccountsReport } from '@/services/api/report.service';

const TestAccountsReport = () => {
    const [reportState, setReportState] = useState({
        status: API_STATES.none,
        error: '',
        data: [],
    });

    const brandReportColumns = useMemo(
        () => [
            {
                Header: 'Company Name',
                accessor: 'companyName',
                className: generalStyles.tableCell,
            },
            {
                Header: 'Company ID',
                accessor: 'companyId',
                className: generalStyles.tableCell,
            },
            {
                Header: 'Subscription',
                accessor: 'subscription',
                className: generalStyles.tableCell,
            },
        ],
        []
    );

    const loadData = async () => {
        try {
            setReportState({ status: API_STATES.loading, error: '', data: [] });
            const result = await getTestAccountsReport();
            if (result.status === API_STATES.success) {
                setReportState({ status: API_STATES.success, error: '', data: result.data });
            } else {
                setReportState({ status: API_STATES.error, error: result.error, data: [] });
            }
        } catch (error) {
            setReportState({ status: API_STATES.error, error: error.message, data: [] });
        } finally {
            setReportState((prevState) => ({ ...prevState, status: API_STATES.success }));
        }
    };

    useEffect(() => {
        loadData();
    }, []);

    return (
        <>
            <h1>Test Accounts</h1>
            <hr />
            <div data-test="generate-report-status">
                {reportState.status === API_STATES.loading && <ByzzerMask loading={true} />}
                <DataTable
                    data={reportState.data}
                    columns={brandReportColumns}
                    downloadFileName={'TestAccounts'}
                    withDownload
                    noDataDescription="No test accounts found"
                />
            </div>
        </>
    );
};

export default TestAccountsReport;
